import axios, { AxiosInstance } from "axios";

/* Create basic AxiosInstance with common properties such as 
 * BaseUrl
 */
const giscoClient: AxiosInstance = axios.create({
    baseURL: "https://gisco-services.ec.europa.eu/api/"
});

export default giscoClient;